import DashView from './components/Dash.vue'
// import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash -  Admin
import DashboardView from './components/views/admin/Dashboard.vue'
import UserView from './components/views/admin/UserView.vue'
import VideosView from './components/views/admin/VideosView.vue'
import DocumentsView from './components/views/admin/DocumentsView'
import CategoryView from './components/views/admin/CategoryView.vue'
import IndustryView from './components/views/admin/IndustryView'
import ProductView from './components/views/admin/ProductView'
import ProfileView from './components/views/admin/profileView'
import AdminLoginView from './components/views/admin/AdminLoginView'
import Organisations from './components/views/admin/Organisations'
import ProductRequest from './components/views/admin/ProductRequest'
import ProductCatalogCategory from './components/views/admin/ProductCatalogCategory'
import ProductCatalogProduct from './components/views/admin/ProductCatalogProduct'
import ProductColours from './components/views/admin/ProductColours'
import ProductType from './components/views/admin/ProductType'
import Distributors from './components/views/admin/Distributors'
// Import Views - Dash -  User
import searchView from './components/views/user/SearchView'
import UserDashView from './components/views/user/layout/UserDashView'
import UserProductsView from './components/views/user/UserProductsView'
import UserTeamView from './components/views/user/UserTeamView'
import UserProfileView from './components/views/user/UserProfileView'
import UserLoginView from './components/views/user/UserLoginView'
import UserForgotPasswordView from './components/views/user/UserForgotPasswordView'
import UserPassResetView from './components/views/user/UserPassResetView'
import UserRegistrationView from './components/views/user/UserRegistrationView'
import UserDouments from './components/views/user/UserDouments'
import UserVideos from './components/views/user/UserVideos'
import UserFavourite from './components/views/user/UserFavourite'
import SingleVideo from './components/views/user/SingleVideo'
import SingleDocuments from './components/views/user/SingleDocument'
import SingleProductPdf from './components/views/user/SingleProductPdf'
import SingleProductVideo from './components/views/user/SingleProductVideo'
import Privacy from './components/Privacy'
import Terms from './components/Terms'
import ProductCatelogue from './components/views/user/ProductCatelogue'
import ProductsView from './components/views/user/ProductsView'
import AllVideosView from './components/views/user/AllVideosView'
import AllDocumentsView from './components/views/user/AllDocumentsView'
import homeView from './components/views/user/homeView'
import SingleProductView from './components/views/user/SingleProductView'
import RequestedList from './components/views/user/RequestedList'
import OrderHistory from './components/views/user/OrderHistory'

// Routes
const routes = [
  {
    path: '/user/login',
    component: UserLoginView
  },
  {
    path: '/user/forgot-password',
    component: UserForgotPasswordView
  },
  {
    path: '/user/reset-password',
    component: UserPassResetView
  },
  {
    path: '/user/register',
    component: UserRegistrationView,
    children: [
      {
        path: 'overview',
        alias: '',
        component: DashboardView,
        name: 'Overview'
      }
    ]
  },
  {
    path: '/admin/login',
    component: AdminLoginView
  },
  {
    path: '/admin',
    component: DashView,
    meta: {
      forAuthAdmin: true
    },
    children: [
      {
        path: 'overview',
        // alias: '',
        component: DashboardView,
        name: 'Overview',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'users',
        component: UserView,
        name: 'Users List',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'videos',
        component: VideosView,
        name: 'Videos List',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'documents',
        component: DocumentsView,
        name: 'Documents List',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'categories',
        component: CategoryView,
        name: 'Category List',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'industries',
        component: IndustryView,
        name: 'Industry List',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'products',
        component: ProductView,
        name: 'product List',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'organisations',
        component: Organisations,
        name: 'Organisations List',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'profile',
        component: ProfileView,
        name: 'Profile',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'product-request',
        component: ProductRequest,
        name: 'Product Request',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'product-catalog-category',
        component: ProductCatalogCategory,
        name: 'Category per Product Catalog',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'product-catalog-product',
        component: ProductCatalogProduct,
        name: 'Product per Product Catalog',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'product-colours',
        component: ProductColours,
        name: 'Product Colours',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'product-type',
        component: ProductType,
        name: 'Product Type',
        meta: {
          forAuthAdmin: true
        }
      }, {
        path: 'distributors',
        component: Distributors,
        name: 'Distributors',
        meta: {
          forAuthAdmin: true
        }
      }
    ]
  },
  {
    path: '/',
    component: UserDashView,
    meta: {
      forAuthUser: true
    },
    children: [
      {
        path: '',
        // alias: '',
        component: homeView,
        name: 'Search Page',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'search-items',
        // alias: '',
        component: searchView,
        name: 'Search Page',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'documents',
        alias: '',
        component: UserDouments,
        name: 'documents'
      },
      {
        path: 'videos',
        alias: '',
        component: UserVideos
      },
      {
        path: 'favourite',
        alias: '',
        component: UserFavourite,
        name: 'favourite'
      },
      {
        path: 'catelogue',
        alias: '',
        component: ProductCatelogue,
        name: 'Product Catalogue'
      },
      {
        path: 'products-view',
        alias: '',
        component: ProductsView,
        name: 'Product View'
      },
      {
        path: 'videos-all',
        alias: '',
        component: AllVideosView,
        name: 'All Videos'
      },
      {
        path: 'docs-all',
        alias: '',
        component: AllDocumentsView,
        name: 'All Manuals'
      },
      {
        path: 'products',
        component: UserProductsView,
        name: 'Products',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'team',
        component: UserTeamView,
        name: 'Team',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'profile',
        component: UserProfileView,
        name: 'Profile',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'videos/single-video/:cata/:id',
        component: SingleVideo,
        name: 'SingleVideo',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'documents/single-dcument/:cata/:id',
        component: SingleDocuments,
        name: 'SingleDocuments',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'products-view/sigle-pdf',
        component: SingleProductPdf,
        name: 'SingleProductPdf',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'products-view/sigle-video',
        component: SingleProductVideo,
        name: 'SingleProductVideo',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'products-view/single-product/:id',
        component: SingleProductView,
        name: 'SingleProductView',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'requested-list',
        component: RequestedList,
        name: 'Requested List',
        meta: {
          forAuthUser: true
        }
      },
      {
        path: 'order-history',
        component: OrderHistory,
        name: 'Order History',
        meta: {
          forAuthUser: true
        }
      }
    ]
  },
  {
    path: '/privacy',
    component: Privacy,
    name: 'Privacy'
  },
  {
    path: '/terms',
    component: Terms,
    name: 'Terms'
  },
  {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js